import { render, staticRenderFns } from "./DisplayDrawNote.vue?vue&type=template&id=3e4240e4"
import script from "./DisplayDrawNote.vue?vue&type=script&lang=js"
export * from "./DisplayDrawNote.vue?vue&type=script&lang=js"
import style0 from "./DisplayDrawNote.vue?vue&type=style&index=0&id=3e4240e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports